function removeParams(keyName: string, urlStr: string) {
  // eslint-disable-next-line
  const name = keyName.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${name}(=([^&#]*(&|#|$))|&|#|$)`);
  return urlStr.replace(regex, (item) => {
    if (/^\?/.test(item)) {
      return "?";
    }
    if (/^&.+&$/.test(item)) {
      return "&";
    }
    if (/#$/.test(item)) {
      return "#";
    }
    return "";
  });
}

function getOriginUrl(url: string): string {
  const decodeUrl = decodeURIComponent(url);
  return decodeUrl === url ? url : getOriginUrl(decodeUrl);
}

export default {
  // eslint-disable-next-line
  get: (keyName: string, url?: string): any => {
    const urlStr = url || window.location.href;
    const originUrl = getOriginUrl(urlStr);
    // eslint-disable-next-line no-useless-escape
    const name = keyName.replace(/[\[\]]/g, "\\$&");
    const regex = new RegExp("[?&]".concat(name, "(=([^&#]*)|&|#|$)"));
    const results = regex.exec(originUrl);
    if (!results) {
      return undefined;
    }
    if (!results[2]) {
      return undefined;
    }
    const res = decodeURIComponent(results[2].replace(/\+/g, " "));
    if (res === "false") {
      return false;
    }
    if (res === "undefined") {
      return undefined;
    }
    if (res === "true") {
      return true;
    }
    if (res && typeof res === "number") {
      return Number(res);
    }
    return res;
  },
  // eslint-disable-next-line
  replace: (paramName: string, replaceWith: any, url: string): string => {
    const oUrl = url || window.location.href.toString();
    const re = new RegExp(`${paramName}=[^&]*`, "gi");

    let nUrl;

    if (
      replaceWith === undefined ||
      replaceWith === null ||
      replaceWith === ""
    ) {
      nUrl = oUrl.replace(re, "");
    } else {
      // eslint-disable-next-line
      nUrl = oUrl.replace(re, `${paramName}=${replaceWith}`);
    }

    return nUrl.replace(/\?$/, "");
  },
  remove: (keyName: string, url: string): void => {
    if (window.history && window.history.replaceState) {
      const urlStr = url || window.location.href;
      window.history.replaceState(
        null,
        // eslint-disable-next-line
        null as any,
        removeParams(keyName, urlStr)
      );
    }
  },
  /**
   * 特殊处理链接值带有+号特殊字符
   * @param originName
   * @param originUrl
   * @return {*}
   */
  // eslint-disable-next-line
  getTicket: (originName: string, originUrl: string): any => {
    let url = originUrl;
    if (!url) {
      url = window.location.href;
    }
    url = `${getOriginUrl(url)}`;
    // eslint-disable-next-line
    const name = originName.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
    const regexS = `[\\?&]${name}=([^&#]*)`;
    const regex = new RegExp(regexS);
    const results = regex.exec(url);
    if (results) {
      results[1] = results[1].replace(/\s+/g, "+");
    }
    return results == null ? null : results[1];
  },
};
